<div class="row">
	<div class="col-12">
		<label>{{ "file_name" | langVal }}</label>
		<app-gen-input
			[actualObj]="this"
			fieldName="file_name"
		>
		</app-gen-input>
	</div>
</div>

<div class="row exp-p">
	<div class="col-6">
		<label>{{ "start_date" | langVal }}</label>
		<app-date-picker
			[actualObj]="exportParamsObj"
			fieldName="exp_start_date"
			title_ph_lang="day"
			[addonObject]="{ after: { icon: 'calendar' } }"
			(changeEvent)="onDateChange(); updateName()"
		>
		</app-date-picker>
	</div>
	<div class="col-6">
		<label>{{ "end_date" | langVal }}</label>
		<app-date-picker
			[actualObj]="exportParamsObj"
			fieldName="exp_end_date"
			title_ph_lang="day"
			#toDate
			[addonObject]="{ after: { icon: 'calendar' } }"
			(changeEvent)="onDateChange(); updateName()"
		>
		</app-date-picker>
	</div>
</div>

<div class="row exp-p">
	<div class="col-12">
		<h4>{{ "source_doc_types" | langVal }}</h4>
	</div>
	<div class="col-12">
		<div class="row exp-p">
			<div class="col-lg-3 doc_types">
				<label for="invoice-doc">
					<h4>{{ "invoices" | langVal }}</h4>
				</label>
				<input
					type="checkbox"
					[(ngModel)]="sourceDocTypeCheckboxes.invoice"
					[checked]="sourceDocTypeCheckboxes.invoice"
					(change)="updateName()"
				/>
			</div>
			<div class="col-lg-3 doc_types">
				<label for="expense-doc">
					<h4>{{ "expenses" | langVal }}</h4>
				</label>
				<input
					type="checkbox"
					[(ngModel)]="sourceDocTypeCheckboxes.expense"
					[checked]="sourceDocTypeCheckboxes.expense"
					(change)="updateName()"
				/>
			</div>
		</div>
	</div>
</div>
<div class="row exp-p">
	<div class="col-12">
		<h4>{{ "export_to_doc" | langVal }}</h4>
	</div>

	<div class="exp-p">
		<app-gen-button-group
			[actualObj]="exportParamsObj"
			fieldName="doc_type"
			optionsListName="export_to_doc_type_opts"
		>
		</app-gen-button-group>
	</div>
</div>
<div class="modal-btns">
	<app-cancel-btn (click)="onClose.emit()" />
	<button
		tabindex="1"
		class="btn btn-primary"
		(click)="dataExport()"
	>
		{{ "export" | langVal }}
	</button>
</div>
